import browserNotSupported from './session-editor/browser-not-supported.html';
import uploadNotAllowedSingleRecording from './session-editor/upload-not-allowed-single-recording.html';

/* @ngInject */
export function templateCache ($templateCache) {
	$templateCache.put('modals/session-editor/browser-not-supported.html', browserNotSupported);
	$templateCache.put('modals/session-editor/upload-not-allowed-single-recording.html', uploadNotAllowedSingleRecording);
}
